export const getSvgPointFromMouseClick = (
  event: React.MouseEvent | React.TouchEvent,
  svgRef: React.RefObject<SVGSVGElement>,
  zoomScale: number
) => {
  if (svgRef.current == null) {
    return;
  }

  const svgScreenCTM = svgRef.current.getScreenCTM();
  if (svgScreenCTM == null) {
    return;
  }

  const svgBoundingBox = svgRef.current.getBoundingClientRect();

  // On iPad these values aren't updated when scaling for some reason
  svgScreenCTM.a = zoomScale;
  svgScreenCTM.d = zoomScale;
  // In firefox these values aren't updated
  svgScreenCTM.e = svgBoundingBox.x;
  svgScreenCTM.f = svgBoundingBox.y;

  let cursorPoint = svgRef.current.createSVGPoint();
  if (event.nativeEvent instanceof MouseEvent) {
    cursorPoint.x = event.nativeEvent.clientX;
    cursorPoint.y = event.nativeEvent.clientY;
  } else if (event.nativeEvent instanceof TouchEvent) {
    cursorPoint.x = event.nativeEvent.changedTouches[0].clientX;
    cursorPoint.y = event.nativeEvent.changedTouches[0].clientY;
  }
  return cursorPoint.matrixTransform(svgScreenCTM.inverse());
};
